import InlineSVG from "react-inlinesvg";
import GeneralBaseModal from "../GeneralBaseModal";
import { SudoButton } from "src/sudokit/components/SudoButton";
import styled from "styled-components/macro";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 8px 4px 0;

  .icon-wrap svg {
    width: 40px;
    height: 40px;
    path {
      stroke: var(--error-red, #d14343);
    }
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.45;
    color: var(--grey-1);
  }
`;

const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  width: 100%;
`;

export default function ImportFailedDialog({ isOpen, hasImportReport, onClose, onOpenProject, onTryAgain }) {
  const message = hasImportReport
    ? "We couldn't finish importing your novel, but your Manuscript Report is saved in the project. Open the project to review it, then try importing again."
    : "We couldn't finish importing your novel. Please try again.";

  return (
    <GeneralBaseModal
      isOpen={isOpen}
      setIsOpen={(open) => {
        if (!open) onClose();
      }}
      title={{ main: "Import failed" }}
      onClose={onClose}
      footer={
        <Footer>
          {hasImportReport && (
            <SudoButton
              variant="primary"
              onClick={onOpenProject}
            >
              Open project
            </SudoButton>
          )}
          <SudoButton
            variant={hasImportReport ? "secondary" : "primary"}
            onClick={onTryAgain}
          >
            Try again
          </SudoButton>
        </Footer>
      }
    >
      <Body>
        <span
          className="icon-wrap"
          aria-hidden="true"
        >
          <InlineSVG src="/assets/close.svg" />
        </span>
        <p>{message}</p>
      </Body>
    </GeneralBaseModal>
  );
}
